import { useEffect, useState } from "react";
import axios from "axios";
import {
  Plane, PlaneTakeoff, TrainFront, BusFront, Ship, Sailboat, Anchor, CarTaxiFront, Car, Caravan, Bike,
  Hotel, Home, BedDouble, Tent, Camera, Mountain, TreePalm, Waves, Landmark, Ticket, Utensils, Luggage,
  Umbrella, Shield, ShieldPlus, Route, Compass, MapPin, Map, Globe, Briefcase, Heart, Star, Sun, Snowflake, FileText,
} from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const VOUCHER_ICONS = {
  plane: Plane, "plane-takeoff": PlaneTakeoff, train: TrainFront, bus: BusFront, ship: Ship, sailboat: Sailboat,
  anchor: Anchor, van: Caravan, "car-taxi": CarTaxiFront, car: Car, bike: Bike, hotel: Hotel, home: Home,
  bed: BedDouble, tent: Tent, camera: Camera, mountain: Mountain, palm: TreePalm, waves: Waves, landmark: Landmark,
  ticket: Ticket, utensils: Utensils, luggage: Luggage, umbrella: Umbrella, shield: Shield, "shield-plus": ShieldPlus,
  route: Route, compass: Compass, "map-pin": MapPin, map: Map, globe: Globe, briefcase: Briefcase, heart: Heart,
  star: Star, sun: Sun, snowflake: Snowflake, "file-text": FileText,
};

export const VoucherTypeIcon = ({ icon, className = "w-5 h-5" }) => {
  const Icon = VOUCHER_ICONS[icon] || FileText;
  return <Icon className={className} />;
};

// "Tienda_León-voucher.pdf" -> "tienda leon voucher pdf"
const normalize = (s) =>
  (s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[_\-.]+/g, " ").replace(/\s+/g, " ").trim();

let cache = null;
const listeners = new Set();

export const reloadVoucherTypes = async () => {
  const res = await axios.get(`${API}/voucher-types`);
  cache = res.data.types || [];
  listeners.forEach((fn) => fn(cache));
  return cache;
};

export const useVoucherTypes = () => {
  const [types, setTypes] = useState(cache || []);
  useEffect(() => {
    listeners.add(setTypes);
    if (!cache) reloadVoucherTypes().catch(() => {});
    return () => listeners.delete(setTypes);
  }, []);
  const byKey = Object.fromEntries(types.map((t) => [t.key, t]));
  const detect = (filename) => {
    const name = normalize(filename);
    // Longest keyword wins so "tienda leon" beats a generic "traslado"
    let best = null;
    types.forEach((t) =>
      (t.keywords || []).forEach((k) => {
        const nk = normalize(k);
        if (nk && name.includes(nk) && (!best || nk.length > best.len)) best = { key: t.key, len: nk.length };
      })
    );
    return best?.key || null;
  };
  return { types, byKey, detect };
};
